import styled from 'styled-components';

export const AuthTitle = styled.p`
  display: flex;
  font-family: 'Kulim Park';
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.48px;
  color: ${p => p.theme.colors.text.text};
  margin-bottom: 24px;
`;

export const SocialBtnWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SocialBtn = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${p =>
    p.theme.ui.scheme === 'dark'
      ? p.theme.colors.main.orangeLight
      : p.theme.colors.main.white};
  flex: 1;
  min-width: 140px;
  height: 40px;
  text-decoration: none;
  border-radius: 30px;
  box-shadow: ${p =>
    p.theme.ui.scheme === 'dark'
      ? '0 4px 20px rgba(0, 0, 0, 0.35)'
      : '4px 4px 16px rgba(170, 178, 197, 0.25)'};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  cursor: pointer;
  font-family: inherit;
  color: ${p => p.theme.colors.text.text};

  svg {
    color: ${p => p.theme.colors.text.text};
    flex-shrink: 0;
  }

  &:hover {
    opacity: 0.9;
  }
`;

export const Text = styled.p`
  font-family: Kulim Park;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.48px;
  margin: 0;
  color: ${p => p.theme.colors.text.text};
`;
